import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:block text-h-neutral-900 !text-xl !medium pb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Listbox = _resolveComponent("Listbox")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Listbox, {
      modelValue: _ctx.topicDefault,
      options: _ctx.topics,
      optionLabel: "label",
      onChange: _ctx.topicSelected,
      class: "hidden md:block p-2 text-h-primary-500 listbox-custom gap-2"
    }, {
      header: _withCtx(() => [
        _createElementVNode("h5", _hoisted_1, _toDisplayString(_ctx.$t("labels.generic", {
              pt: "Explorar tópicos",
              en: "Explore topics",
            })), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "options", "onChange"]),
    _createVNode(_component_Dropdown, {
      options: _ctx.topics,
      optionLabel: "label",
      modelValue: _ctx.topicExplored,
      onChange: _ctx.topicSelected,
      class: "md:!hidden w-full custom-dropdown"
    }, null, 8, ["options", "modelValue", "onChange"])
  ]))
}